import React from 'react'
import {
  UnitsSectionEyebrow,
  UnitsSectionIntro,
  UnitsSectionTitle,
} from '../styled'

export const UnitsSectionIntroBlock: React.FC<{
  startingPrice: number | null
}> = ({ startingPrice }) => (
  <UnitsSectionIntro className="units-intro">
    <UnitsSectionEyebrow className="units-intro__eyebrow">
      Storage Options
    </UnitsSectionEyebrow>
    <UnitsSectionTitle className="units-intro__title">
      Starting at{' '}
      {startingPrice ? `$${startingPrice}/month` : 'competitive monthly rates'}.
    </UnitsSectionTitle>
  </UnitsSectionIntro>
)
